import React, { useEffect, useState } from "react";
import "./Who_Should_Use_This.css";
import Who_Should_Use_This_img_holder from "../../../Common_Component/Who_Should_Use_This_img_holder/Who_Should_Use_This_img_holder";
import { useParams } from "react-router-dom";

function Who_Should_Use_This() {
  const [data, setData] = useState();
  const { id } = useParams();

  useEffect(() => {
    const filteredArray = Who_Should_Use_This_data?.find(
      (item) => item?.id === Number(id)
    );
    setData(filteredArray);
  }, [id]);

  const Who_Should_Use_This_data = [
    {
      id: 1,
      imagecount: 3,
      heading: "Digital Screens",

      img1: "/Assets/Images/Service/Services_inner/Multimedia_Services/Degital_screens/img1.png",
      title1: "Retail brands",
      descn1: "showcasing seasonal offers or discounts.",
      img2: "/Assets/Images/Service/Services_inner/Multimedia_Services/Degital_screens/img2.png",
      title2: "Real estate firms ",
      descn2: "advertising new developments.",
      img3: "/Assets/Images/Service/Services_inner/Multimedia_Services/Degital_screens/img3.png",
      title3: "FMCG brands  ",
      descn3: "aiming for high visibility in crowded marketplaces.",
    },
    {
      id: 2,
      imagecount: 3,
      heading: "redio",

      img1: "/Assets/Images/Service/Services_inner/Multimedia_Services/Redio/img1.png",
      title1: "Local businesses ",
      descn1: "looking to connect with their immediate communities.",
      img2: "/Assets/Images/Service/Services_inner/Multimedia_Services/Redio/img2.png",
      title2: "Brands launching",
      descn2: " products in new regions.",
      img3: "/Assets/Images/Service/Services_inner/Multimedia_Services/Redio/img3.png",
      title3: "Event organizers",
      descn3: " promoting concerts or fairs.",
    },

    {
      id: 3,
      imagecount: 3,
      heading: "TV",

      img1: "/Assets/Images/Service/Services_inner/Multimedia_Services/TVS/img1.png",
      title1: "National brands  ",
      descn1: "launching new products.",
      img2: "/Assets/Images/Service/Services_inner/Multimedia_Services/TVS/img2.png",
      title2: "Businesses looking to ",
      descn2: " boost brand recognition.",
      img3: "/Assets/Images/Service/Services_inner/Multimedia_Services/TVS/img3.png",
      title3: "E-commerce platforms ",
      descn3: " targeting large customer bases.",
    },

    {
      id: 4,
      imagecount: 3,
      heading: "TV",

      img1: "/Assets/Images/Service/Services_inner/Multimedia_Services/Theator/img1.png",
      title1: "Luxury brands",
      descn1: " looking for premium visibility.",
      img2: "/Assets/Images/Service/Services_inner/Multimedia_Services/Theator/img2.png",
      title2: "Local businesses ",
      descn2: " targeting a cinema-going audience.",
      img3: "/Assets/Images/Service/Services_inner/Multimedia_Services/Theator/img3.png",
      title3: "E-commerce platforms ",
      descn3: "promoting offers to urban youth.",
    },

    {
      id: 5,
      imagecount: 4,
      heading: "TV",

      img1: "/Assets/Images/Service/Services_inner/Multimedia_Services/Airport/img1.png",
      title1: "Luxury brands",
      descn1: " looking for premium visibility.",
      img2: "/Assets/Images/Service/Services_inner/Multimedia_Services/Airport/img2.png",
      title2: "Restaurants, ",
      descn2: "cafes, or duty-free shops advertising offers.",
      img3: "/Assets/Images/Service/Services_inner/Multimedia_Services/Airport/img3.png",
      title3: "Travel agencies",
      descn3: "promoting packages or services",
      img4: "/Assets/Images/Service/Services_inner/Multimedia_Services/Airport/img4.png",
      title4: "Tech companies",
      descn4: "showcasing gadgets and innovations",
    },
  ];

  return (
    <>
      <section className="Who_Should_Use_This">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-4 col-md-3">
              <div className="heading_holder">
                <h3>
                  Who <br /> Should <br /> Use This?
                </h3>
              </div>
            </div>

            <div className="col-xl-7 col-lg-8 col-md-9">
              <div className="Who_Should_Use_This_card_holder">
                <div className="row">
                  <div className="col-md-6 col-sm-6 col-12">
                    <div className=" row">
                      <div className="col-md-12 mb-4">
                        <Who_Should_Use_This_img_holder
                          image={data?.img1}
                          headingText={data?.title1}
                          subText={data?.descn1}
                        />
                      </div>

                      <div className="col-md-12 mb-4">
                        <Who_Should_Use_This_img_holder
                          image={data?.img2}
                          headingText={data?.title2}
                          subText={data?.descn2}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-6 col-12 mb-4">
                    {data?.imagecount === 3 ? (
                      <>
                        <Who_Should_Use_This_img_holder
                          image={data?.img3}
                          headingText={data?.title3}
                          subText={data?.descn3}
                        />
                      </>
                    ) : (
                      <>
                        <div className=" row">
                          <div className="col-md-12 mb-4">
                            <Who_Should_Use_This_img_holder
                              image={data?.img3}
                              headingText={data?.title3}
                              subText={data?.descn3}
                            />
                          </div>

                          <div className="col-md-12 mb-4">
                            <Who_Should_Use_This_img_holder
                              image={data?.img4}
                              headingText={data?.title4}
                              subText={data?.descn4}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Who_Should_Use_This;
